import React, { Component } from 'react';

//Components
import NavBar from '../../../../_components/common/Navbar';
import Footer from '../../../../_components/common/Footer';
import SettingsHead from '../../../../_components/common/SettingsHead';
import { CommonBreadCrumb } from '../../../../_components/common/CommonBreadCrumb';
import ModalNew2 from '../../../../_components/common/ModalNew2';
import Moment from 'react-moment';
import { LoaderComp } from '../../../../_components/common/LoaderComp/Loadercomp';
import Page404 from '../../../404page';




//redux 
import { connect } from 'react-redux';

//css
import './details.css';
import { worksheetAction } from '../../../../_actions';

class WorksheetDetails extends Component {
    state = {
        QandA_data: [],
        responseQandA: [],
        saveWorksheetModal: false,
        commentSectionState: false,
        submitted: false,
        modalTextError: false,
        commentValue: '',
        modalText: {
            text: 'Are you sure you want to save this worksheet?'
        },
        workSheetId: null,

        hasProperId: true,
        idLoader: true
    }
    componentDidMount() {
        this.setState({
            workSheetId: +this.props.match.params.id
        })
        const paramId = +this.props.match.params.id;
        const { dispatch } = this.props;
        dispatch(worksheetAction.getWorkSheetDetailsHandler(paramId, (response) => {
            this.setState({
                responseQandA: response.data.worksheet_goal
            })
        }))
        dispatch(worksheetAction.getCommentListHandler(paramId));
        dispatch(worksheetAction.getSharedWithUsersHandler(paramId));
        dispatch(worksheetAction.getSharedUsersHandler());

        let hasId = false
        if (this.props.location.state) {
            this.props.location.state.sellerData.assessment &&
                dispatch(worksheetAction.getWeakAreaHandler(this.props.location.state.sellerData))
            hasId = true
        } else {
            hasId = false
        }

        this.setState({
            hasProperId: hasId,
            idLoader: false
        })




        this.setState({
            QandA_data: []
        })
    }

    saveAsPDF(data) {

        const { QandA_data, } = this.state;
        let flag = 0;
        for (let i = 0; i < QandA_data.length; i++) {
            if (QandA_data[i].goal_setting_desc === '') {

                flag = flag + 1
            }
        }
        if (flag === 0 && this.state.QandA_data.length !== 0) {
            const fd = {
                'worksheet_id': this.state.workSheetId,
            }
            this.props.dispatch(worksheetAction.saveWorksheetHandler(fd))
        }
    }

    saveWorksheetToggle(data) {
        let modalText = this.state.modalText;
        modalText.text = 'Are you sure you want to save this worksheet?'
        this.setState({
            saveWorksheetModal: data,
            modalTextError: false,
            modalText: modalText,
        })
    }

    onClickSaveAssessment = () => {
        const { dispatch } = this.props;
        let objIfNoPassCondition = {
            type: 'SHARE_WORKSHEET_ERROR',
            meta: {
                closeModal: 'Please Answer all the questions'
            }
        }
        if (this.state.modalTextError === false) {
            const QandA_data = this.state.QandA_data.length === 0 ? this.props.getWorkSheetDetailsResponse.worksheet_goal : this.state.QandA_data;
            let flag = 0;
            for (let i = 0; i < QandA_data.length; i++) {
                if (QandA_data[i].goal_setting_desc.trim() === '') {
                    flag = flag + 1
                }
            }

            if (flag > 0) {
                let modalText = this.state.modalText;
                modalText.text = 'All Questions Mandatory'
                this.setState({
                    modalText: modalText,
                    modalTextError: true,
                }, () => {
                    dispatch(objIfNoPassCondition)
                })
            }

            if (flag === 0 && (this.state.QandA_data.length === 0 || this.props.getWorkSheetDetailsResponse.length !== 0)) {
                const fd = {
                    'worksheet_id': this.state.workSheetId,
                    'worksheet_text': this.state.QandA_data
                }
                this.props.dispatch(worksheetAction.saveWorksheetHandler(this.state.workSheetId, fd, () => {
                    this.setState({
                        saveWorksheetModal: false
                    })
                }))
            }
        }
        else {
            if (this.state.modalTextError === true) {
                this.setState({
                    saveWorksheetModal: false
                }, () => {
                    dispatch(objIfNoPassCondition)
                })
            }
        }
    }

    onChangeQandA = (event, data, id) => {
        for (let i = 0; i < data.length; i++) {
            if (data[i].attribute_id === id) {
                data[i].goal_setting_desc = event.target.value;
            }
        }
        this.setState({
            QandA_data: data
        })

    }



    commentToggler(e, state) {

        e.stopPropagation();
        this.setState({
            commentSectionState: state,
        })
    }

    onChange = (event) => {
        const { name, value } = event.target;
        this.setState({ [name]: value });
    }

    onsubmitComment = () => {
        let sharedIds;
        let worksheetIds;
        for (let i = 0; i < this.props.workSheetSharedData.length; i++) {
            if (this.props.workSheetSharedData[i].worksheet_id === this.state.workSheetId) {
                sharedIds = this.props.workSheetSharedData[i].id
                worksheetIds = this.props.workSheetSharedData[i].worksheet_id

            }
        }


        const commentData = {
            "worksheet": worksheetIds,
            "shared_work_sheet": sharedIds,
            'comment': this.state.commentValue
        }

        this.props.dispatch(worksheetAction.saveCommentHandler(commentData))
        this.setState({
            submitted: true,
            commentValue: ''
        })
    }

    workSheetShareDisable = (response) => {
        let count = 0;


        for (let i = 0; i < response.length; i++) {
            if (response[i].goal_setting_desc === '') {
                count = count + 1;
            }
        }
        if (count > 0) {
            return true
        }
        else if (count === 0) {
            return false
        }
    }

    render() {
        const { getCommentListResponse, getWorkSheetDetailsResponse, getSharedWithUsersResponse, getWeakAreaResponse } = this.props;

        return (
            <div className="worksheet-details">
                <NavBar />
                {
                    this.state.idLoader ?
                        <div style={{ height: 'calc(100vh - 150px)' }} className="container d-flex justify-content-center">
                            <LoaderComp color={'black'} />
                        </div>
                        :
                        this.state.hasProperId ?
                            <div>
                                {
                                    this.props.location.state ?
                                        <div className="container mb-5">
                                            <CommonBreadCrumb
                                                data={[
                                                    {
                                                        link: '/app/dashBoard',
                                                        name: 'DASHBOARD'
                                                    }, {
                                                        link: '/app/dashBoard/workSheet',
                                                        name: 'GOAL-SETTING WORKSHEETS'
                                                    }, {
                                                        link: '',
                                                        name: 'WORKSHEET DETAILS'
                                                    }
                                                ]}
                                            />
                                            <div style={{ height: 40 }} className="bg-green rounded-top animation-fade-in">
                                                <p className="h6 text-center text-uppercase py-2 text-white mb-0 quattrocentosans regular">
                                                    {this.props.location.state.sellerData.orientation__orientation_name !== null ? this.props.location.state.sellerData.orientation__orientation_name + '- ORIENTATION ' : ''}{this.props.location.state.sellerData.worksheet_name}</p>
                                            </div>

                                            {
                                                this.props.location.state.sellerData.assessment &&
                                                <SettingsHead
                                                    buttonData={
                                                        [
                                                            {
                                                                id: 1,
                                                                heading: "SAVE WORKSHEET",
                                                                state: false,
                                                                toggler: this.saveWorksheetToggle.bind(this),
                                                            }, {
                                                                id: 2,
                                                                heading: "SAVE AS PDF",
                                                                state: false,
                                                                link: 'pdf'
                                                            }
                                                        ]
                                                    }
                                                    pdfName={"vpiScore"}
                                                    pdfData={{
                                                        worksheet_id: this.state.workSheetId
                                                    }}
                                                    pathname={`/app/dashBoard/viewReport/0/download`}
                                                    externalLinks={
                                                        [
                                                            {
                                                                id: 1,
                                                                heading: "MANAGE WORKSHEET SHARE",
                                                                link: "manageWorksheetShare",
                                                                disabled: this.workSheetShareDisable(getWorkSheetDetailsResponse !== '' ? getWorkSheetDetailsResponse.worksheet_goal : []),

                                                            }
                                                        ]
                                                    }
                                                    sellerState={this.props.location.state.sellerData}
                                                    secondColumn={true}
                                                    widthClass="col-md-6"
                                                />
                                            }

                                            <AchievementTable

                                                currentEmail={getWorkSheetDetailsResponse !== '' ? getWorkSheetDetailsResponse.shared_by : ''}
                                                showNote={!this.props.location.state.sellerData.assessment}
                                                showNoteData={getWeakAreaResponse !== '' ? getWeakAreaResponse : ''}
                                                sharedWith={getSharedWithUsersResponse !== '' ? getSharedWithUsersResponse : []}
                                            />
                                            {
                                                getWorkSheetDetailsResponse !== '' &&
                                                getWorkSheetDetailsResponse.worksheet_goal.map((val, i) => {
                                                    return <QandA key={i} count={i} disabled={getCommentListResponse !== '' ? getCommentListResponse.is_shared_with_me : false} id={val.attribute_id} question={val.attribute__attribute_name} placeholder={''} stateValue={this.state.QandA_data} value={val.goal_setting_desc} onChangeQandA={(event, id) => this.onChangeQandA(event, this.state.QandA_data.length === 0 ? this.props.getWorkSheetDetailsResponse.worksheet_goal : this.state.QandA_data, id)} />
                                                })
                                            }
                                            <CommentSection comments={getCommentListResponse !== '' ? getCommentListResponse.comments : []} showCommentBox={getCommentListResponse.is_shared_with_me} onClick={(e, state) => this.commentToggler(e, state)} openState={this.state.commentSectionState} stateData={this.state.commentValue} onChange={(event) => this.onChange(event)} onsubmitComment={this.onsubmitComment} />
                                        </div>
                                        :
                                        null
                                }
                            </div>
                            :
                            <Page404 unauthorised={true} />
                }

                {
                    this.state.saveWorksheetModal &&
                    <ModalNew2
                        heading="SAVE ASSESSMENT"
                        showModal={this.state.saveWorksheetModal}
                        formData={[]}
                        action={() => this.onClickSaveAssessment()}
                        toggleModal={this.saveWorksheetToggle.bind(this)}
                        viewMessage={[this.state.modalText]}
                        triggerType={this.state.modalTextError ? "OK" : "YES"}
                        onlyCancel={true}
                    />
                }
                <Footer />
            </div>
        )
    }
}

const CommentSection = ({ comments, showCommentBox, onClick, openState, stateData, onChange, onsubmitComment }) => {
    return (
        <div className={openState ? "comment-section comment-open" : "comment-section comment-close"} onClick={openState === false ? (e) => onClick(e, true) : () => { }}>
            <i className={openState ? "fa fa-comments fa-2x comment-fade-out" : "fa fa-comments fa-2x comment-fade-in"}></i>
            <div className={openState ? 'commentAreaOpen' : 'commentAreaClose'}>
                {
                    openState &&
                    <div className="mt-5 comment-fade-in">
                        <div className="close-func-class justify-content-end" onClick={(e) => onClick(e, false)}>
                            x close
                        </div>
                        {
                            showCommentBox === true &&
                            <div style={{ width: '100%', maxWidth: '50rem', padding: '0px 2rem', background: 'rgb(70, 69, 69)' }}>
                                <textarea name="commentValue" value={stateData} onChange={(event) => onChange(event)} rows="1" placeholder="Write a comment" style={{ padding: '0.8rem', border: '0rem', background: 'rgb(238, 238, 238)', borderRadius: '3px 0px 0px 3px', height: '3rem', width: '90%', maxHeight: '100px', resize: 'none' }}>
                                </textarea>
                                <button className="relative-position" onClick={() => onsubmitComment()} style={{ overflow: 'visible', float: 'right', border: '0px', padding: '0px', cursor: 'default', color: 'rgb(255, 255, 255)', textTransform: 'uppercase', background: 'rgb(26, 163, 136)', borderRadius: '0px 3px 3px 0px', textShadow: 'rgba(0, 0, 0, 0.3) 0px -1px 0px', height: '3rem', width: '10%' }}>
                                    <i className="fa fa-arrow-right"></i>
                                </button>
                            </div>
                        }

                        <div className="py-5 px-2">
                            {
                                comments.length === 0 &&
                                <p className="text-center"
                                    style={{ fontSize: '14px', padding: '0 10px' }}
                                >No comments</p>
                            }
                            {
                                comments.map((val, i) => (
                                    <div className="hoverDiv" key={i}>
                                        <div >
                                            <span
                                                style={{ paddingLeft: '5px', margin: 0, color: '#a9b9b9' }}
                                            >{val.shared_work_sheet__shared_to__email}</span>
                                            <span className={'hoverEffect'} style={{
                                                float: 'right',
                                                fontSize: 10,
                                                color: '#cecece'
                                            }}><Moment fromNow>{val.created}</Moment></span>
                                        </div>
                                        <p
                                            style={{ fontSize: '14px', padding: '0 10px' }}
                                        >{val.comment}</p>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                }
            </div>
        </div>
    )
}

const QandA = ({ count, id, stateValue, disabled, question, placeholder, value, onChangeQandA }) => {

    return (
        <div key={count} style={{}}>
            <div>
                <span>{count + 1}</span>. <span>{question}</span>
            </div>
            <div>
                <textarea
                    style={{ backgroundColor: disabled === true ? 'rgb(235, 235, 228)' : 'transparent' }}
                    disabled={disabled}
                    value={stateValue.length === 0 ? value : stateValue[count].goal_setting_desc}
                    onChange={(event) => onChangeQandA(event, id)}
                    placeholder={placeholder}
                    className="textAreaQA"
                ></textarea>
            </div>
        </div>
    )
}

const AchievementTable = ({ currentEmail, sharedWith, showNote, showNoteData }) => {

    return (
        <table className="table">
            <tbody>
                <tr>
                    <td>Shared By</td>
                    <td>{currentEmail}</td>
                </tr>
                <tr>
                    <td>Shared with</td>
                    <td>{sharedWith.length !== 0 ? sharedWith.map(
                        (data, i) => {
                            return <span key={i}>{data.shared_to__email} {sharedWith.length - 1 === i ? '' : sharedWith.length - 2 === i ? ' and ' : ', '}</span>
                        }
                    ) : 'You have not yet shared this worksheet'}</td>
                </tr>
                {
                    showNote === false &&
                    <tr>
                        <td colSpan="2" className="text-center">
                            Note:
                            <i><b>{showNoteData.weak_attribute}</b> is your weak area in <b>{showNoteData.orientation}</b>. You may want to seek inputs from your {showNoteData !== '' && showNoteData.assessor_groups.map(
                                (data, i) => {
                                    return <span key={i}>{data.assessor_name}{showNoteData.assessor_groups.length === i + 1 ? '' : ', '}</span>
                                }
                            )} when filling out that area below.</i>
                        </td>
                    </tr>
                }

            </tbody>
        </table>
    )
}

const mapStateToProps = state => {

    const { getCommentListLoading } = state.getCommentListReducer;
    const getCommentListError = state.getCommentListReducer.error;
    const getCommentListResponse = (!getCommentListLoading && !getCommentListError) ? state.getCommentListReducer.data.data : '';

    const { getWorkSheetDetailsLoading } = state.getWorkSheetDetailsReducer;
    const getWorkSheetDetailsError = state.getWorkSheetDetailsReducer.error;
    const getWorkSheetDetailsResponse = (!getWorkSheetDetailsLoading && !getWorkSheetDetailsError) ? state.getWorkSheetDetailsReducer.data.data : '';

    const { getSharedWithUsersLoading } = state.getSharedWithUsersReducer;
    const getSharedWithUsersError = state.getSharedWithUsersReducer.error;
    const getSharedWithUsersResponse = (!getSharedWithUsersLoading && !getSharedWithUsersError) ? state.getSharedWithUsersReducer.data.data.shared_with_list : '';

    const workSheetSharedError = state.getSharedUsersReducer.error;
    const { getSharedUsersLoading } = state.getSharedUsersReducer;
    const workSheetSharedData = (!workSheetSharedError && !getSharedUsersLoading) ? state.getSharedUsersReducer.data.data.response : '';

    const { getWeakAreaLoading } = state.getWeakAreaReducer;
    const getWeakAreaError = state.getWeakAreaReducer.error;
    const getWeakAreaResponse = (!getWeakAreaLoading && !getWeakAreaError) ? state.getWeakAreaReducer.data.data : '';
    return {
        getCommentListResponse,
        getWorkSheetDetailsResponse,
        getSharedWithUsersResponse,
        workSheetSharedData,
        getWeakAreaResponse
    }
}

export default connect(mapStateToProps)(WorksheetDetails)


// WEBPACK FOOTER //
// ./src/_pages/DashBoard/worksheet/worksheetdetails/details.jsx